import { createRequest } from '../../services/request';

export const UPLOAD_FILE = createRequest('FILE_UPLOAD/UPLOAD_FILE');
export const DELETE_FILE = createRequest('FILE_UPLOAD/DELETE_FILE');
